import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Box, Card, Link, Typography } from '@mui/material';
import List from '@mui/material/List';
import { isRoleCheckList, sortByDate } from 'app/utils/appHelpers';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AnnouncementItem from '../Item/AnnouncementItem';


const hasShownDialogForUserStore = {};
let lastSeenAuthUserIdStore = null;

function DashboardAnnouncementsCard({ }) {

    const [announcements, setAnnouncements] = useState([])
    const [firstNewAnnouncementId, setFirstNewAnnouncementId] = useState(null);
    const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);
    const allAnnouncements = useSelector(state => state.general.announcements);
    const authUser = useSelector(state => state.auth.authUser);
    const navigate = useNavigate();

    const hasShownDialogForUserRef = useRef(hasShownDialogForUserStore);

    const userRoles = authUser && authUser.userRoles ? authUser.userRoles : [];
    const isAllowedForAnnouncements =
        authUser && userRoles.length > 0
            ? isRoleCheckList(userRoles, [373, 370, 369, 372, 416, 417])
            : false;

    const isAnnouncementNew = (announcement) => {
        if (!announcement || !announcement.addedDate) return false;
        const announcementDate = new Date(announcement.addedDate);
        const threeDaysAgo = new Date();
        threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
        return announcementDate >= threeDaysAgo;
    };

    useEffect(() => {
        let data = allAnnouncements.filter(x => x.status === 1)
        data = sortByDate(data, "addedDate", "desc")
        if (allAuthorizedInsts.length > 0) {
            data = data.filter(x => {
                const toAnnouncementArray = x.toAnnouncement ? x.toAnnouncement.split(',').map(item => item.trim()) : [];

                return toAnnouncementArray.some(inst => allAuthorizedInsts.includes(inst));
            });
        }
        setAnnouncements(data)
    }, [allAnnouncements, allAuthorizedInsts])


    useEffect(() => {
        const currentUserId = authUser && authUser.id ? String(authUser.id) : null;

        if (!currentUserId) {
            lastSeenAuthUserIdStore = null;
            return;
        }

        // Yeni login / kullanıcı değişimi: flag'i sıfırla
        // Not: lastSeenAuthUserIdStore dosya-scope olduğu için component remount olsa bile korunur.
        if (currentUserId !== lastSeenAuthUserIdStore) {
            hasShownDialogForUserRef.current[currentUserId] = false;
            lastSeenAuthUserIdStore = currentUserId;
        }
    }, [authUser?.id]);


    useEffect(() => {
        const currentUserId = authUser && authUser.id ? String(authUser.id) : null;
        if (!currentUserId) {
            setFirstNewAnnouncementId(null);
            return;
        }

        if (!isAllowedForAnnouncements) {
            setFirstNewAnnouncementId(null);
            return;
        }

        const hasShown = hasShownDialogForUserRef.current[currentUserId] === true;
        if (hasShown) {
            setFirstNewAnnouncementId(null);
            return;
        }

        const firstNew = announcements.find(a => isAnnouncementNew(a));
        setFirstNewAnnouncementId(firstNew && firstNew.id ? firstNew.id : null);
    }, [authUser?.id, isAllowedForAnnouncements, announcements])

    const handleViewAllAnnouncements = () => {
        navigate('/listAnnouncement');
    };


    if (!isAllowedForAnnouncements) {
        return null;
    }

    return (

        <Card
            sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: 2,
                padding: '10px',
                maxHeight: '550px',
                minHeight: '385px',
                overflow: 'auto'

            }}
        >
            <JumboScrollbar
                autoHeight
                autoHeightMin={360}
                autoHeightMax={550}
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Typography
                    sx={{ fontSize: '13px', padding: '5px', paddingBottom: '10px' }}
                >
                    Duyurular
                </Typography>
                <List disablePadding>
                    {
                        announcements.map((announcement, index) => (
                            <AnnouncementItem
                                key={announcement && announcement.id ? announcement.id : index}
                                announcement={announcement}
                                autoOpen={announcement && announcement.id ? announcement.id === firstNewAnnouncementId : false}
                                onDialogOpen={() => {
                                    const currentUserId = authUser && authUser.id ? String(authUser.id) : null;
                                    if (currentUserId) {
                                        hasShownDialogForUserRef.current[currentUserId] = true;
                                    }
                                    // Tekrar tetiklenmesini engellemek için id'yi temizle
                                    setFirstNewAnnouncementId(null);
                                }}
                            />
                        ))
                    }
                </List>

                {/* Tüm Duyurular Linki */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '10px 0',
                    borderTop: '1px solid #e0e0e0',
                    marginTop: '10px'
                }}>
                    <Link
                        component="button"
                        variant="body2"
                        onClick={handleViewAllAnnouncements}
                        sx={{
                            color: 'primary.main',
                            textDecoration: 'none',
                            fontSize: '12px',
                            fontWeight: 'medium',
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline',
                                color: 'primary.dark'
                            }
                        }}
                    >
                        Tüm Duyurular
                    </Link>
                </Box>
            </JumboScrollbar>
        </Card>


    );
};

export default DashboardAnnouncementsCard